import addParam from '../addParam'

export default class {
  constructor(opt) {
    if (!opt.openid || (!opt.openkey && !opt.thirdToken)) {
      console.error("session_third need openid,openkey|thirdToken params");
    }

    this.openid = opt.openid;
    this.openkey = opt.openkey;
    	/**
		 * thirdToken
		 */
    this.thirdToken = opt.thirdToken;
  }

  getSessionParam() {
    if (this.thirdToken) {
      return {
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.thirdToken),
        session_id: 'hy_gameid',
        session_type: 'st_third_party'
      };
    } else {
      return {
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.openkey),
        session_id: 'hy_gameid',
        session_type: 'st_local_third_party'
      };
    }
  }

  addSessionParam(url) {
    if (this.thirdToken) {
      return addParam({
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.thirdToken),
        sessionid: 'hy_gameid',
        sessiontype: 'st_third_party'
      }, url);
    } else if (this.accessToken) {
      return addParam({
        openid: encodeURIComponent(this.openid),
        openkey: encodeURIComponent(this.openkey),
        sessionid: 'hy_gameid',
        sessiontype: 'st_local_third_party'
      }, url);
    }
  }
}
